var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.333 54H6.667C3 54 0 50.962 0 47.25V6.75C0 3.038 3 0 6.667 0h166.666C177 0 180 3.038 180 6.75v40.5c0 3.712-3 6.75-6.667 6.75z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.333 0H6.667C3 0 0 3.038 0 6.75v40.5C0 50.962 3 54 6.667 54h166.666C177 54 180 50.962 180 47.25V6.75c0-3.712-3-6.75-6.667-6.75zm0 1.08c3.088 0 5.6 2.544 5.6 5.67v40.5c0 3.127-2.512 5.67-5.6 5.67H6.667c-3.088 0-5.6-2.543-5.6-5.67V6.75c0-3.126 2.512-5.67 5.6-5.67h166.666z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.225 13.829c0 1.13-.331 2.031-.994 2.703-.752.8-1.733 1.199-2.939 1.199-1.154 0-2.136-.405-2.944-1.216-.808-.81-1.212-1.816-1.212-3.015 0-1.2.404-2.204 1.212-3.015.808-.81 1.79-1.216 2.944-1.216.573 0 1.122.113 1.642.34.521.226.939.527 1.252.904l-.704.713c-.53-.641-1.258-.961-2.19-.961-.842 0-1.57.3-2.185.899-.614.6-.922 1.378-.922 2.336s.308 1.736.922 2.336c.615.6 1.343.9 2.185.9.893 0 1.638-.302 2.235-.905.387-.393.61-.94.67-1.64h-2.905v-.974h3.877c.037.212.056.415.056.612",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.225 13.829h-.134c0 1.105-.32 1.963-.954 2.608h-.002v.002c-.729.771-1.665 1.155-2.843 1.157-1.124-.002-2.064-.39-2.85-1.177-.784-.788-1.171-1.75-1.173-2.919.002-1.17.39-2.13 1.173-2.919.786-.787 1.726-1.176 2.85-1.177.556 0 1.085.11 1.59.328.505.22.904.51 1.201.868l.102-.087-.094-.095-.703.713.094.095.103-.087c-.554-.672-1.332-1.011-2.293-1.01-.873 0-1.642.316-2.277.938-.642.624-.964 1.446-.963 2.433 0 .987.322 1.809.963 2.433.636.622 1.404.938 2.277.937.923.002 1.71-.315 2.329-.944.413-.42.648-1.001.71-1.724l.012-.147h-2.918v-.703h3.744v-.135l-.131.024c.036.205.053.4.053.588h.267a3.61 3.61 0 00-.058-.636l-.02-.11H59.16v1.242h3.038v-.135l-.132-.011c-.06.679-.273 1.19-.633 1.556-.573.578-1.276.864-2.14.865-.81 0-1.499-.284-2.092-.86-.587-.576-.88-1.31-.881-2.24.001-.93.294-1.664.881-2.24.593-.576 1.281-.86 2.092-.86.902.002 1.582.303 2.088.913l.094.112.806-.816.086-.088-.078-.094c-.328-.396-.764-.71-1.301-.943a4.213 4.213 0 00-1.695-.35c-1.185-.001-2.208.42-3.038 1.255-.833.833-1.252 1.88-1.251 3.111-.001 1.23.418 2.278 1.252 3.111.829.835 1.852 1.256 3.037 1.255 1.234.001 2.258-.414 3.036-1.24l-.097-.094.094.096c.691-.699 1.034-1.643 1.033-2.8h-.133zM69.37 10.445h-3.643v2.568h3.285v.974h-3.285v2.568h3.643v.995H64.7v-8.1h4.67v.995z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.37 10.445v-.135h-3.776v2.838h3.285v.703h-3.285v2.839h3.643v.725h-4.404v-7.83h4.404v.86h.133v-.135.135h.134v-1.13h-4.937v8.37h4.937V16.42H65.86v-2.298h3.286v-1.244H65.86V10.58h3.644v-.135h-.134M73.705 17.55h-1.028v-7.105h-2.235V9.45h5.498v.995h-2.235v7.105z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.705 17.55v-.135h-.895V10.31h-2.234v-.725h5.23v.725h-2.234v7.24h.133v-.135.135h.134v-6.97h2.234V9.315h-5.764v1.265h2.234v7.105H73.84v-.135h-.134M79.917 17.55v-8.1h1.028v8.1h-1.028z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.917 17.55h.133V9.585h.761v7.83h-.894v.135h.133-.133v.135h1.161v-8.37h-1.294v8.37h.133v-.135zM85.505 17.55h-1.029v-7.105h-2.234V9.45h5.497v.995h-2.234v7.105z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.505 17.55v-.135h-.896V10.31h-2.234v-.725h5.23v.725h-2.234v7.24h.134v-.135.135h.133v-6.97h2.234V9.315h-5.764v1.265h2.235v7.105h1.295v-.135h-.133M93.04 15.825c.591.607 1.316.91 2.173.91.856 0 1.581-.303 2.172-.91.593-.607.89-1.383.89-2.325 0-.942-.297-1.718-.89-2.325-.59-.607-1.316-.91-2.172-.91-.857 0-1.582.303-2.174.91-.591.607-.888 1.383-.888 2.325 0 .942.297 1.718.888 2.325zm5.106.678c-.787.82-1.765 1.228-2.933 1.228-1.17 0-2.148-.409-2.933-1.228-.787-.818-1.178-1.819-1.178-3.003 0-1.184.391-2.185 1.178-3.003.785-.82 1.763-1.228 2.933-1.228 1.162 0 2.138.41 2.928 1.233.789.822 1.184 1.821 1.184 2.998 0 1.184-.394 2.185-1.18 3.003z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.04 15.825l-.096.095c.614.631 1.38.952 2.269.95a3.051 3.051 0 002.267-.95c.618-.632.93-1.45.928-2.42.001-.97-.31-1.788-.928-2.42a3.051 3.051 0 00-2.267-.95 3.053 3.053 0 00-2.269.95c-.616.632-.928 1.45-.926 2.42-.002.97.31 1.788.926 2.42l.095-.095.095-.095c-.566-.583-.849-1.316-.85-2.23.001-.914.284-1.647.85-2.23.57-.583 1.252-.869 2.079-.87.825.001 1.508.287 2.078.87.566.583.85 1.316.85 2.23 0 .914-.284 1.647-.85 2.23-.57.583-1.253.869-2.078.87-.827-.001-1.508-.287-2.08-.87l-.094.095zm5.106.678l-.096-.094c-.764.794-1.699 1.185-2.837 1.187-1.14-.002-2.075-.393-2.837-1.187l-.004-.004.004.004c-.764-.795-1.14-1.755-1.141-2.909.001-1.154.377-2.114 1.14-2.91.763-.792 1.698-1.185 2.838-1.186 1.13.001 2.064.395 2.832 1.193.766.799 1.145 1.757 1.146 2.903-.001 1.154-.379 2.114-1.14 2.91l.095.093.096.094c.808-.84 1.217-1.883 1.216-3.097 0-1.207-.41-2.247-1.222-3.092-.812-.847-1.83-1.276-3.023-1.274-1.2-.002-2.221.425-3.029 1.269-.81.84-1.217 1.883-1.216 3.097 0 1.214.406 2.257 1.216 3.098l.004.003-.004-.004c.808.844 1.829 1.27 3.029 1.269 1.199.001 2.22-.425 3.029-1.269l-.096-.094M100.767 17.55v-8.1h1.251l3.888 6.301h.045l-.045-1.56V9.45h1.029v8.1h-1.073l-4.068-6.607h-.044l.044 1.562v5.045h-1.027z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M100.767 17.55h.134V9.585h1.043l3.888 6.301h.256l-.048-1.698V9.585h.762v7.83h-.866l-4.068-6.607h-.255l.048 1.7v4.907h-.894v.135h.134-.134v.135h1.161v-5.182l-.045-1.563-.133.003v.135h.044v-.135l-.113.072 4.107 6.67h1.28v-8.37h-1.295v4.877l.044 1.563.134-.004v-.135h-.045v.135l.113-.071-3.927-6.365h-1.458v8.37h.133v-.135zM142.581 40.5h2.488V23.623h-2.488V40.5zm22.41-10.797l-2.852 7.317h-.086l-2.96-7.317h-2.68l4.439 10.226-2.531 5.689h2.596l6.84-15.915h-2.766zm-14.11 8.88c-.816 0-1.952-.412-1.952-1.433 0-1.303 1.416-1.802 2.638-1.802 1.094 0 1.608.239 2.273.565-.193 1.563-1.523 2.67-2.959 2.67zm.3-9.25c-1.801 0-3.666.804-4.438 2.585l2.208.933c.472-.933 1.35-1.238 2.273-1.238 1.287 0 2.595.782 2.616 2.172v.173c-.451-.26-1.415-.65-2.595-.65-2.38 0-4.804 1.323-4.804 3.798 0 2.259 1.952 3.713 4.139 3.713 1.673 0 2.595-.76 3.175-1.65h.085v1.303h2.401v-6.47c0-2.996-2.208-4.669-5.06-4.669zm-15.376 2.424h-3.538v-5.785h3.538c1.86 0 2.916 1.56 2.916 2.893 0 1.308-1.056 2.892-2.916 2.892zm-.064-8.134h-5.961V40.5h2.487v-6.394h3.474c2.758 0 5.468-2.021 5.468-5.241 0-3.22-2.71-5.242-5.468-5.242zm-32.508 14.963c-1.718 0-3.158-1.457-3.158-3.458 0-2.022 1.44-3.502 3.158-3.502 1.697 0 3.029 1.48 3.029 3.502 0 2.001-1.332 3.458-3.029 3.458zm2.857-7.938h-.086c-.558-.674-1.633-1.283-2.986-1.283-2.835 0-5.434 2.522-5.434 5.763 0 3.219 2.599 5.72 5.434 5.72 1.353 0 2.428-.61 2.986-1.305h.086v.827c0 2.197-1.16 3.371-3.029 3.371-1.525 0-2.47-1.11-2.857-2.044l-2.17.913c.624 1.522 2.278 3.393 5.027 3.393 2.922 0 5.392-1.74 5.392-5.981v-10.31h-2.363v.936zm4.081 9.852h2.492V23.623h-2.492V40.5zm6.165-5.568c-.064-2.218 1.697-3.349 2.965-3.349.988 0 1.826.5 2.104 1.218l-5.069 2.131zm7.733-1.913c-.472-1.284-1.912-3.654-4.854-3.654-2.922 0-5.349 2.327-5.349 5.741 0 3.22 2.406 5.742 5.628 5.742 2.599 0 4.103-1.61 4.726-2.544l-1.933-1.306c-.644.958-1.526 1.588-2.793 1.588-1.267 0-2.169-.587-2.75-1.74l7.583-3.175-.258-.652zm-60.41-1.893v2.436h5.756c-.172 1.37-.623 2.37-1.31 3.067-.838.848-2.148 1.783-4.447 1.783-3.544 0-6.315-2.892-6.315-6.48 0-3.59 2.771-6.482 6.315-6.482 1.912 0 3.308.761 4.34 1.74l1.696-1.718c-1.439-1.393-3.35-2.458-6.036-2.458-4.854 0-8.936 4.002-8.936 8.917s4.082 8.917 8.936 8.917c2.621 0 4.597-.87 6.144-2.501 1.59-1.61 2.083-3.871 2.083-5.698a8 8 0 00-.129-1.523h-8.098zm14.771 7.46c-1.719 0-3.2-1.435-3.2-3.48 0-2.066 1.481-3.48 3.2-3.48 1.718 0 3.2 1.414 3.2 3.48 0 2.045-1.482 3.48-3.2 3.48zm0-9.221c-3.136 0-5.693 2.414-5.693 5.741 0 3.306 2.557 5.742 5.693 5.742 3.136 0 5.692-2.436 5.692-5.742 0-3.327-2.556-5.741-5.692-5.741zm12.418 9.221c-1.718 0-3.2-1.435-3.2-3.48 0-2.066 1.482-3.48 3.2-3.48 1.718 0 3.2 1.414 3.2 3.48 0 2.045-1.482 3.48-3.2 3.48zm0-9.221c-3.136 0-5.692 2.414-5.692 5.741 0 3.306 2.555 5.742 5.692 5.742 3.136 0 5.692-2.436 5.692-5.742 0-3.327-2.556-5.741-5.692-5.741z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.013 43.726l-.099-.096c-.388-.416-.617-1.061-.617-1.897v.197-29.857-.007V12.271c0-.905.267-1.587.714-1.996l16.52 16.726-16.518 16.725zm-.716-31.661zm.006-.221v-.003.003zm0-.01v-.002.002z",
    fill: "url(#paint0_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.037 32.776l.126-.072 6.523-3.753c.622-.358 1.037-.792 1.244-1.252-.206.46-.621.894-1.244 1.252l-6.523 3.753-.126.072zm.002-.198l-5.508-5.577 5.507-5.576 6.648 3.824c.845.486 1.319 1.112 1.398 1.752v.002c-.08.638-.553 1.265-1.398 1.75l-6.648 3.825",
    fill: "url(#paint1_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.19 44.363a1.706 1.706 0 00.001 0zm.001-.198c-.461 0-.864-.152-1.178-.439L30.531 27l5.508 5.577-19.354 11.134c-.535.307-1.043.453-1.494.453zm-1.183-.245a1.907 1.907 0 01-.086-.084l.086.084z",
    fill: "url(#paint2_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.531 27.001l-16.52-16.726a1.704 1.704 0 011.178-.438c.452 0 .96.146 1.496.454l19.353 11.134L30.531 27zm5.632-5.702L16.684 10.094c-.537-.308-1.044-.454-1.496-.454h-.006.008c.45 0 .958.145 1.494.453L36.163 21.3z",
    fill: "url(#paint3_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.314 44.36c.419-.025.883-.17 1.37-.45l19.353-11.134-19.352 11.133c-.488.28-.952.426-1.371.45zm-1.302-.436l-.004-.004a.039.039 0 01.005.004zm-.09-.088l-.008-.009.008.009z",
    fill: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.037 32.776l.126-.072-.126.072z",
    fill: "url(#paint4_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.192 44.363c-.462 0-.865-.153-1.179-.44v.001a.025.025 0 00-.005-.004l-.086-.084-.008-.01.1-.1c.313.287.716.44 1.177.439.451 0 .958-.145 1.494-.453l19.354-11.134.123.126-.125.072-19.352 11.133c-.488.28-.952.426-1.371.45a2.518 2.518 0 01-.122.004",
    fill: "url(#paint5_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.914 43.827c-.388-.416-.617-1.061-.617-1.897 0 .836.229 1.48.617 1.897",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.914 43.827c-.388-.416-.617-1.061-.617-1.897v-.197c0 .836.229 1.481.617 1.897l.1.096-.1.1",
    fill: "url(#paint6_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.914 43.827l.1-.101-.1.1",
    fill: "url(#paint7_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.93 27.7a1.692 1.692 0 010 0z",
    fill: "#000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.163 32.704l-.124-.126 6.647-3.825c.845-.485 1.319-1.112 1.398-1.75 0 .234-.052.468-.154.696-.207.46-.622.894-1.244 1.252l-6.523 3.753z",
    fill: "url(#paint8_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.084 27.001c0-.707-.467-1.413-1.398-1.949L36.163 21.3h-.001l6.524 3.753c.932.536 1.399 1.243 1.398 1.95z",
    fill: "#404040"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.084 27c-.08-.64-.553-1.265-1.398-1.75l-6.648-3.825.124-.126 6.524 3.753c.931.536 1.397 1.242 1.398 1.949z",
    fill: "url(#paint9_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.297 12.066v-.001.001zm.006-.22v-.002.003zm0-.005v-.007.007zm0-.008c.077-1.387.822-2.188 1.876-2.193a1.703 1.703 0 00-1.167.439v-.001l-.003.004c-.033.03-.064.061-.095.094-.35.375-.57.937-.61 1.656z",
    fill: "#404040"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.297 12.27v-.196-.008-.001c0-.075.002-.148.006-.218v-.003-.003-.007-.002c.04-.72.261-1.28.611-1.656l.098.1c-.448.408-.715 1.09-.715 1.995zm.712-2.188l.003-.004c0 .002-.002.003-.003.004z",
    fill: "url(#paint10_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.038 21.425L16.685 10.29c-.537-.308-1.044-.454-1.496-.454-.461 0-.864.152-1.178.438l-.097-.099c.03-.033.062-.064.095-.094l.003-.003c.312-.285.71-.436 1.167-.44H15.188c.453 0 .96.147 1.497.455l19.478 11.205h-.001l-.124.126z",
    fill: "url(#paint11_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.066,
    y1: 11.758,
    x2: 6.412,
    y2: 34.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 45.112,
    y1: 27.002,
    x2: 12.85,
    y2: 27.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 33.103,
    y1: 30.1,
    x2: 2.381,
    y2: 60.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9.73,
    y1: 0.238,
    x2: 23.448,
    y2: 13.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 45.112,
    y1: 27.002,
    x2: 12.85,
    y2: 27.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 33.103,
    y1: 30.1,
    x2: 2.381,
    y2: 60.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 29.066,
    y1: 11.758,
    x2: 6.412,
    y2: 34.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 33.103,
    y1: 30.1,
    x2: 2.382,
    y2: 60.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 45.113,
    y1: 27.002,
    x2: 12.85,
    y2: 27.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 45.113,
    y1: 27.002,
    x2: 12.85,
    y2: 27.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 29.066,
    y1: 11.758,
    x2: 6.412,
    y2: 34.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 9.73,
    y1: 0.238,
    x2: 23.448,
    y2: 13.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.c0ea3eeff11cc333561ea98b79c43992.svg";
export { ForwardRef as ReactComponent };